export default {
  applies_to_articles: 'Van toepassing op de volgende items',
};
